<div class="content">
  <div class="image-wrapper">
    <img [attr.src]="imageSrc" />
  </div>
</div>

<label><ng-content></ng-content></label>
